import React, { useEffect, useState, useCallback, useMemo } from "react";
import { Box, Card, Typography, Button, Stack } from "@mui/material";
import Sidebar from "../sidebar/sidebar";
import { getSecureItem } from "../../utilsFunctions";
import axios from "axios";
import { BaseUrl } from "../../Environment";
import LoadingPage from "../modals/LoadingPage/LoadingPage";
import { companylogo } from "../../assets/images";

const Partner = () => {
  const authToken = useMemo(() => getSecureItem("token"), []);
  const companyId = useMemo(() => getSecureItem("loggedinUserCompany"), []);

  const [accessToken, setAccessToken] = useState("");
  const [loading, setLoading] = useState(true);

  const openInNewTab = useCallback(() => {
    window.open(
      "https://auth.razorpay.com/authorize?client_id=S67lnxsRooZNsc&response_type=code&redirect_uri=https://www.lendstack.app/&scope=read_write&state=test1",
      "_blank",
      "noopener,noreferrer",
    );
  }, []);

  const getCompanyDetails = useCallback(async () => {
    try {
      const { data } = await axios.get(`${BaseUrl}/company/getCompanyProfile`, {
        params: { companyId },
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });

      if (data?.accessToken) {
        setAccessToken(data.accessToken);
      }
    } catch (error) {
      console.error("User details error:", error);
    } finally {
      setLoading(false);
    }
  }, [authToken, companyId]);

  useEffect(() => {
    getCompanyDetails();
  }, [getCompanyDetails]);

  return (
    <>
      <Sidebar />

      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        className="paddingSidebar"
      >
        <img src={companylogo} alt="logo" />
      </Stack>
      {loading ? (
        <LoadingPage isLoading={loading} />
      ) : (
        <Box
          sx={{
            // minHeight: "100vh",
            bgcolor: "#fff",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            p: 2,
            ml: "70px",
            mt: "150px"
          }}
        >
          <Card
            sx={{
              width: "100%",
              maxWidth: 720,
              borderRadius: 4,
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
              overflow: "hidden",
            }}
          >
            {accessToken ? (
              <Box sx={{ p: 4, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                <Typography variant="h6" fontWeight={600}>
                  🎉 Razorpay account connected
                </Typography>
                <Typography style={{maxWidth: "500px", textAlign: "center"}}>
                  You have already authorized LendStack to access Razorpay for
                  mandate and payment processing.
                </Typography>
              </Box>
            ) : (
              <>
                <Box
                  sx={{
                    bgcolor: "#0c0f4d",
                    color: "#fff",
                    p: 4,
                  }}
                >
                  <Typography variant="h6" fontWeight={600}>
                    Connect Razorpay
                  </Typography>
                </Box>

                <Box
                  sx={{
                    p: 4,
                  }}
                >
                  <div className="Fonts">
                    To enable <strong>Digital Collections, Payment Links, and eNACH,</strong> please connect your Razorpay account.
                  </div>
                  <ul className="Fonts">
                    <li><strong>Already have a Razorpay account?</strong> Sign in and authorize access.</li>
                    <li><strong>New to Razorpay?</strong> Sign up and complete the quick KYC process (takes about <strong>3-5 minutes</strong>).</li>
                  </ul>
                  <div className="Fonts">
                    Once done, return here and click <strong>Authorize</strong> to complete the connection.
                  </div>
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    p: 3,
                    borderTop: "1px solid #eee",
                  }}
                >
                  <Button
                    onClick={openInNewTab}
                    variant="contained"
                    sx={{
                      px: 4,
                      textTransform: "none",
                      fontWeight: 600,
                    }}
                  >
                    Authorize
                  </Button>
                </Box>
              </>
            )}
          </Card>
        </Box>
      )}
    </>
  );
};

export default Partner;
